import { useState, useEffect } from 'react'
import { fetchData } from '../../../../global/utils/fetch'
import { STATUS, IAuditImage } from '../../../../global/types/audit'
import { getExampleImages as getExampleImagesAPI } from '../../../../global/context/audit-context/api'

interface UseExampleImagesOptions {
  auditType: STATUS | null
  sectionKey: string
}

/**
 * Hook to fetch example images dynamically for a specific audit type and section
 * Returns IAuditImage[] to match the ImagesDisplay component's expected format
 */
export function useExampleImages({
  auditType,
  sectionKey,
}: UseExampleImagesOptions) {
  const [exampleImages, setExampleImages] = useState<IAuditImage[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!auditType || !sectionKey) {
      setExampleImages([])
      return
    }

    const fetchImages = async () => {
      setIsLoading(true)
      try {
        const images = await fetchData<IAuditImage[]>(
          getExampleImagesAPI(auditType, sectionKey)
        )

        if (images && images.length > 0) {
          setExampleImages(images)
        } else {
          setExampleImages([])
        }
      } catch (error) {
        console.error('Failed to fetch example images:', error)
        setExampleImages([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchImages()
  }, [auditType, sectionKey])

  return {
    exampleImages,
    isLoading,
  }
}
